import React, { useState, useEffect } from 'react'
import 'styles/footer.scss'
import { getCookie } from 'utils/cookie'

const getClassName = revampViewBucket =>
  ['A', 'B', 'D'].includes(revampViewBucket) ? 'footerWrap' : 'revampFooterWrap'

function Footer() {
  const [state, setState] = useState({
    revampViewBucket: '',
  })
  useEffect(() => {
    const revampViewBucket = getCookie('revampView')
    setState({ revampViewBucket })
  }, [])

  return (
    <div className={getClassName(state.revampViewBucket)}>
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            &copy; 1996-{new Date().getFullYear()} Shaadi.com, The World's Leading
            Matchmaking Service&trade;
          </div>
          <div className="col-md-4 createdBy">
            Passionately created by{' '}
            <a
              href="http://people-group.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              People Group
              <span className="rightSmallArrow" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
